// extracted by mini-css-extract-plugin
export default {"uploadPhoto":"UploadFile_uploadPhoto__uHcTV","passport":"UploadFile_passport__gNykC"};